import { select, Store } from "@ngrx/store";
import {MultiCartSelectors, MultiCartStatePersistenceService, StateWithMultiCart } from "@spartacus/cart/base/core";
import { CartType } from "@spartacus/cart/base/root";
import { OCC_USER_ID_ANONYMOUS, SiteContextParamsService, StatePersistenceService, UserIdService } from "@spartacus/core";
import {combineLatest, distinctUntilChanged, filter, map, Observable} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class SikoB2bMultiCartStatePersistenceService extends MultiCartStatePersistenceService {
    constructor(
        protected statePersistenceService: StatePersistenceService,
        protected store: Store<StateWithMultiCart>,
        protected siteContextParamsService: SiteContextParamsService,
        protected userIdService: UserIdService
    ) {
        super(
            statePersistenceService,
            store,
            siteContextParamsService
        );
    }

    protected getCartState(): Observable<{ active: string }> {
        return combineLatest([
            this.store.pipe(
                // Since getCartState() may be called while the module is lazy loaded.
                // The cart state slice may not exist yet in the first store emissions.
                filter((store) => !!store.cart),
                select(MultiCartSelectors.getMultiCartState),
                filter((state) => !!state),
                map((state) => state.index[CartType.ACTIVE] ?? ''),
            ),
            this.userIdService.getUserId(),
        ]).pipe(
            // Only persist the active cart id for anonymous users.
            // Logged-in cart codes must never be stored: if the session expires or the
            // browser is closed without an explicit logout, the stale code would be
            // sent to the backend as oldCartId on the next login, causing 4xx errors.
            // For logged-in users the backend always identifies the active cart via
            // the auth token, so falling back to OCC_CART_ID_CURRENT is safe.
            // For more info see https://siko.atlassian.net/browse/B2X-3574
            map(([activeCartId, userId]) => ({
                active: userId === OCC_USER_ID_ANONYMOUS ? activeCartId : '',
            })),
            distinctUntilChanged((a, b) => a.active === b.active),
        );
    }
}
